import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const OrderServices = {
  order: async (data) => {
    const response = await apiService.post("/order", data);
    return response.data;
  },
  getOrderList: async ({
    tableId = "",
    pageNumber = 1,
    pageSize = 10,
    orderReferenceNo = "",
    orderStatus = "",
    paymentStatus = "",
  } = {}) => {
    const params = new URLSearchParams({
      ...(tableId && { tableId: tableId.toString() }),
      ...(orderReferenceNo && { orderRefrenceId: orderReferenceNo }),
      ...(orderStatus && { orderStatus: orderStatus }),
      ...(paymentStatus && { paymentStatus: paymentStatus }),
      pageNumber: pageNumber.toString(),
      pageSize: pageSize.toString(),
    });

    try {
      const res = await apiService.get(`/order?${params.toString()}`);
      return res.data;
    } catch (err) {
      console.log("Error getting order list. ERR:", err);
      throw err;
    }
  },

  getOrderDetailList: async ({
    pageNumber = 1,
    pageSize = 10,
    refNumber = "",
    fromDate = "",
    toDate = "",
    productName = "",
  } = {}) => {
    const params = new URLSearchParams({
      // ...(tableId && { tableId: tableId.toString() }),
      ...(refNumber && { orderRef: refNumber }),
      ...(fromDate && { fromDate }),
      ...(toDate && { toDate }),
      ...(productName && { productName }),
      // ...(orderStatus && { orderStatus: orderStatus }),
      // ...(paymentStatus && { paymentStatus: paymentStatus }),
      page: pageNumber.toString(),
      pageSize: pageSize.toString(),
    });

    try {
      const res = await apiService.get(
        `/order/orderdetails?${params.toString()}`
      );
      return res.data;
    } catch (err) {
      console.log("Error getting order list. ERR:", err);
      throw err;
    }
  },

  getOrderDetail: async (orderRefNumber) => {
    try {
      const response = await apiService.get(
        `/order/refNumber/${orderRefNumber}`
      );
      return response.data;
    } catch (err) {
      console.log("error on getting order detail. ERR: ", err);
    }
  },

  // getOrderDetailList: async (orderId) => {
  //   try {
  //     const response = await apiService.get(`/order/orderdetails`);
  //     return response.data;
  //   } catch (err) {
  //     console.log("error on getting order detail. ERR: ", err);
  //   }
  // },

  getByTable: async (tableId) => {
    const response = await apiService.get(`/order/ongoing/${tableId}`);
    return response.data;
  },

  // checkout: async (orderId, paymentTypeId) => {
  //   const response = await apiService.post(
  //     `/order/${orderId}/pay?paymentTypeId=${paymentTypeId}`
  //   );
  //   return response.data;
  // },
  checkout: async (data) => {
    const response = await apiService.post(`/order/mark-paid`, data);
    return response.data;
  },
  productDetail: async (id) => {
    const response = await apiService.get(`/products/${id}`);
    return response.data;
  },

  deleteItem: async (orderDetailId) => {
    const response = await apiService.delete(`/order/items/${orderDetailId}`);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/products/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  updateStatus: async (OrderDetailId, status) => {
    try {
      const response = await apiService.put(
        `/order/items/${OrderDetailId}/status?newStatus=${status}`
      );
      return response.data;
    } catch (error) {
      console.error("Error updating order status:", error);
      throw error;
    }
  },

  cancelOrder: async (orderId) => {
    const response = await apiService.post(`/order/${orderId}/cancel`);
    return response.data;
  },
  mulipleOrderCancel: async (tableId, itemIds, remarks) => {
    const response = await apiService.delete(
      `/order/items?tableId=${tableId}&Remarks=${encodeURIComponent(remarks)}`,
      { data: itemIds }
    );
    return response.data;
  },

  kotprint: async (tableId) => {
    const response = await apiService.post(
      `/order/sendforprint?tableId=${tableId}`
    );
    return response.data;
  },
};

export default OrderServices;
